import _ from "underscore";
import functionnal from "./functionnal.js";
import formaters from "./formaters.js";
const checkers = {
    containsUpperCase(str) {
        return str !== str.toLowerCase();
    },
    isAllUpperCase(str) {
        const re = new RegExp("^[A-Z]+$");
        if (!re.test(str)) {
            return false;
        }
        return str.length > 0 && str.toUpperCase() === str;
    },
    isPortable: function (tel) {
        "use strict";
        if (!tel) {
            return false;
        }
        const formatedTel = formaters.formatTelNumberForStoring(tel);
        if (formatedTel) {
            var re = /^0[67][0-9]{8}$/;
            return re.test(formatedTel);
        }
        else {
            return false;
        }
    },
    isFixe: function (inputTel) {
        "use strict";
        const tel = formaters.formatTelNumberForStoring(inputTel);
        if (tel) {
            var re = /^0[1-59][0-9]{8}$/;
            return re.test(tel);
        }
    },
    isEmail: function (email) {
        "use strict";
        if (!functionnal.existy(email)) {
            return false;
        }
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    isNomOrPrenom: function (item) {
        "use strict";
        if (!functionnal.existy(item)) {
            return false;
        }
        var re = /^[a-zA-Z\séèàù\-ëôïÉÈ'çÇÏê]+$/;
        return re.test(item);
    },
    isValidDdn: function (ddn) {
        "use strict";
        var re = /^[0-3][0-9]\/[01][0-9]\/[12][09][0-9][0-9]$/;
        return re.test(ddn);
    },
    isString: function (stringToTest) {
        "use strict";
        return stringToTest && typeof stringToTest === "string";
    },
    isDate: function (dateToTest) {
        "use strict";
        return dateToTest instanceof Date && !isNaN(dateToTest.valueOf());
    },
    objectHasEmptyField: function (obj) {
        "use strict";
        for (let prop in obj) {
            if (obj[prop]) {
                if (!functionnal.existy(obj[prop])) {
                    return true;
                }
            }
        }
        return false;
    },
    isValidDuree: function (int, dureeMinRdv) {
        "use strict";
        if (!Number.isInteger(int)) {
            return false;
        }
        return Number.isInteger(int / dureeMinRdv);
    },
    isEven: function (num) {
        "use strict";
        return num % 2 === 0;
    },
    isOdd: function (num) {
        return !this.isEven(num);
    },
    isValidHM(hm) {
        "use strict";
        if (hm && _.isNumber(hm.heure) && _.isNumber(hm.minute)) {
            return (hm.heure >= 0 && hm.heure < 24 && hm.minute >= 0 && hm.minute <= 59);
        }
        return false;
    },
    is164(tel) {
        if (!_.isString(tel)) {
            return false;
        }
        return formaters.formatTelNumberForE164(tel) === tel;
    },
    isNumberString(number) {
        return ((number.substr(0, 1) !== "0" || number.length === 1) &&
            !Number.isNaN(parseInt(number)));
    },
    isValidDate(date) {
        if (date instanceof Date) {
            return !Number.isNaN(date.valueOf());
        }
        return false;
    },
    isValidYearString(year) {
        if (year.length !== 4) {
            return false;
        }
        if (isNaN(parseInt(year))) {
            return false;
        }
        if (year.slice(0, 2) !== "20" && year.slice(0, 2) !== "19") {
            return false;
        }
        return true;
    },
};
export default checkers;
//# sourceMappingURL=checkers.js.map